const screenshotWidth = 1920;
const screenshotHeight = 1080;
const padding = 130;
const extraVerticalPadding = 200

export const config = {
    screenshotWidth,
    screenshotHeight,
    padding,
    extraVerticalPadding,
    canvasWidth: 1920 + padding * 2, 
    canvasHeight: 1080 + padding * 2 + extraVerticalPadding, 
    bgColor: "#eceef3",
    adjustedBgColor: "#eeedf2",
    maxTooltipWidth: 800,
    tooltipPadding: 10,
    tooltipBorderRadius: 16,
    industrySector: "solicitor",

    fontSizes: [
        process.env.SCREENSHOT_FONT_SIZE_LG || '34',
        process.env.SCREENSHOT_FONT_SIZE_MD || '44',
        process.env.SCREENSHOT_FONT_SIZE_SM || '54'
    ],
    slots: [
        { y: 2, x: 10, width:1000,height:100},
        { y: 5, x: 1150, width:100,height:100},
        { y: 400, x: 10, maxWidth: 500, width:100,height:100},
        { y: 1210, x: 20, width:100,height:100},
        { y: 1190, x: 1120, width:100,height:100 }
    ],
    lineWidth: 2
};
 